module.exports = __webpack_public_path__ + "la.svg?d4742a0bc73e9af721f7b7e6c08c4720";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/4x3/la.svg
// module id = 1205
// module chunks = 0